import { Input, Select } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../../../../nestserver";
import DailyScheduleTask from "../../../../admin/pages/components/manageschedule/DailyScheduleTask";
const Schedule = () => {
  const { Option } = Select;
  const [filterDay, setFilterDay] = useState(null);
  const [filterEventId, setFilterEventId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [classId, setClassId] = useState({
    name: null,
    id: null,
  });
  const [filterName, setFilterName] = useState(null);

  //fetch events
  const fetchEvent = async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/event/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };
  const getEvent = useQuery("event", fetchEvent);
  async function fetchStudent() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/students/by-parent/`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data.result;
  }
  const students = useQuery("students/by-parent", fetchStudent);

  useEffect(() => {
    if (!students?.data?.length) return;

    const selectedStudent = filterName
      ? students.data.find((item) => item._id === filterName)
      : students.data[0];

    if (selectedStudent) {
      setClassId({
        name: selectedStudent?.class?.name,
        id: selectedStudent?.class?._id,
      });
    }
  }, [students?.data, filterName]);

  //handle class Select change
  const handleSelectChange = (id) => {
    setFilterName(id);
  };

  const handleEventSelectChange = (id) => {
    setFilterEventId(id);
  };



  const handleDayChange = (name) => {
    setFilterDay(name);

    switch (name) {
      case "day":
        // Set startDate and endDate to today's date
        const today = moment().format("YYYY-MM-DD");
        setStartDate(today);
        setEndDate(today);
        break;
      case "weekly":
        // Get the start and end dates of the current week
        const currentDate = moment();
        const startOfWeek = currentDate.clone().startOf("week");
        const endOfWeek = currentDate.clone().endOf("week");
        const weekStartDate = startOfWeek.format("YYYY-MM-DD");
        const weekEndDate = endOfWeek.format("YYYY-MM-DD");
        setStartDate(weekStartDate);
        setEndDate(weekEndDate);
        break;
      case "monthly":
        // Get the start and end dates of the current month
        const currentMonth = moment();
        const startOfMonth = currentMonth.clone().startOf("month");
        const endOfMonth = currentMonth.clone().endOf("month");
        const monthStartDate = startOfMonth.format("YYYY-MM-DD");
        const monthEndDate = endOfMonth.format("YYYY-MM-DD");
        setStartDate(monthStartDate);
        setEndDate(monthEndDate);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <div className="p-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full "
        >
          <div className="text-2xl text-orange-500 font-semibold pb-8">
            Schedule 
          </div>
          <div className="flex items-center gap-4">
            <div className="flex gap-4  items-center">
              <h3 className="text-base font-semibold">Name</h3>
              <Select
                showSearch
                showArrow
                placeholder="Select name"
                className="w-full bg-gray-300"
                style={{
                  border: "6px",
                  backgroundColor: "#EBEBEB",
                }}
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(value) => handleSelectChange(value)}
              >
                {students &&
                  students?.data?.map((data) => {
                    return (
                      <Option key={data._id} value={data._id}>
                        {`${data?.first_name} ${data?.last_name}`}
                      </Option>
                    );
                  })}
              </Select>
            </div>
            <div className="flex gap-4 w-273 items-center">
              <h3 className="text-base font-semibold">Class</h3>
              <Input readOnly value={classId?.name} />
            </div>

            <div className="flex gap-4 w-273 items-center">
              <h3 className="text-base font-semibold">Period</h3>
              <Select
                showSearch
                showArrow
                style={{ width: 200 }}
                placeholder="Select day"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={handleDayChange}
                allowClear
              >
                <Option value="day">Day</Option>
                <Option value="weekly">Weekly</Option>
                <Option value="monthly">Month</Option>
              </Select>
              {startDate && endDate && (
                <span className="text-sm text-gray-500">
                  {startDate === endDate
                    ? moment(startDate).format("DD MMM YYYY")
                    : `${moment(startDate).format("DD MMM")} - ${moment(endDate).format("DD MMM YYYY")}`}
                </span>
              )}
            </div>
          <div className="flex items-center gap-4">
            <div className="flex gap-4 w-273 items-center">
              <h3 className="text-base font-semibold">Event</h3>
              <Select
                showSearch
                showArrow
                style={{ width: 200 }}
                placeholder="Select event"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={handleEventSelectChange}
                className="capitalize"
                allowClear
              >
                {getEvent?.isSuccess &&
                  getEvent?.data?.result?.data.length > 0 &&
                  getEvent?.data?.result?.data?.map((data) => {
                    return (
                      <Option
                        key={data._id}
                        value={data._id}
                        className="capitalize"
                      >
                        {data.name}
                      </Option>
                    );
                  })}
              </Select>
            </div>
          </div>
          </div>
          <div>
            <DailyScheduleTask
              filterDay={filterDay}
              filterClassId={classId?.id}
              filterEventId={filterEventId}
            />
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default Schedule;
